import React from 'react';
import styles from './BubbleBadge.scss';
var OPACITY = 0.12;
var replaceOpacity = function (rgba, opacity) {
    var rgb = rgba
        .replace('rgba', '')
        .replace('rgb', '')
        .replace('(', '')
        .replace(')', '');
    var rgbArray = rgb.split(',');
    var r = rgbArray[0];
    var g = rgbArray[1];
    var b = rgbArray[2];
    return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
};
var convertHexToRGBA = function (hex, opacity) {
    var hexValue = hex.replace('#', '');
    var r = parseInt(hexValue.substring(0, 2), 16);
    var g = parseInt(hexValue.substring(2, 4), 16);
    var b = parseInt(hexValue.substring(4, 6), 16);
    return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
};
var getRgbaFromTextColor = function (textColor) {
    var isHex = /^#([A-Fa-f0-9]{3}){1,2}$/.test(textColor);
    return isHex
        ? convertHexToRGBA(textColor, OPACITY)
        : replaceOpacity(textColor, OPACITY);
};
var BubbleBadge = function (_a) {
    var text = _a.text, image = _a.image, fontFamily = _a.fontFamily, _b = _a.textColor, textColor = _b === void 0 ? '#000000' : _b;
    return (React.createElement("div", { className: styles.badges },
        React.createElement("div", { key: textColor, style: {
                background: getRgbaFromTextColor(textColor),
            }, className: styles.wrapper, "aria-hidden": "true", "data-hook": "chat-badge-wrapper" },
            React.createElement("div", { className: styles.badge },
                image && (React.createElement("img", { "data-hook": "chat-badge-image", className: styles.icon, src: image, alt: text })),
                React.createElement("div", { className: styles.text, style: {
                        fontFamily: fontFamily,
                    }, "data-hook": "chat-badge-text" }, text)))));
};
export default BubbleBadge;
//# sourceMappingURL=BubbleBadge.js.map